<template>
  <div class="wf-relative wf-top-0 wf-min-h-screen">
    <div
      id="toolbar"
      style="width: 427px;"
      class="wf-flex wf-z-50 wf-fixed wf-shadow-lg wf-flex-wrap wf-h-screen"
      :style="toolbar ? 'left: 0px;' : 'left:-427px;'"
    >
      <div class="wf-w-1/6 wf-bg-blue-500 wf-max-h-screen">
        <ul class="wf-flex wf-flex-col wf-h-full">
          <li>
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-text-xl wf-cursor-pointer wf-text-white hover:wf-bg-blue-700"
              :class="menu == 'meta' ? 'wf-bg-blue-700' : ''"
              href="#"
              @click.prevent="menu = 'meta'"
            >
              <i class="fas fa-info-circle"></i>
              <span class="wf-text-xxs wf-lowercase">Meta</span>
            </a>
          </li>
          <li>
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-text-xl wf-cursor-pointer wf-text-white hover:bg-blue-700"
              :class="menu == 'styles' ? 'wf-bg-blue-700' : ''"
              href="#"
              @click.prevent="menu = 'styles'"
            >
              <i class="fab fa-css3"></i>
              <span class="wf-text-xxs wf-lowercase">Styles</span>
            </a>
          </li>
          <li>
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-text-xl wf-cursor-pointer wf-text-white hover:bg-blue-700"
              :class="menu == 'scripts' ? 'wf-bg-blue-700' : ''"
              href="#"
              @click.prevent="menu = 'scripts'"
            >
              <i class="fab fa-js"></i>
              <span class="wf-text-xxs wf-lowercase">Scripts</span>
            </a>
          </li>
          <li>
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-text-xl wf-cursor-pointer wf-text-white hover:bg-blue-700"
              :class="menu == 'pixels' ? 'wf-bg-blue-700' : ''"
              href="#"
              @click.prevent="menu = 'pixels'"
            >
              <i class="fas fa-cubes"></i>
              <span class="wf-text-xxs wf-lowercase">Pixels</span>
            </a>
          </li>
          <li>
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-text-xl wf-cursor-pointer wf-text-white hover:bg-blue-700"
              :class="menu == 'elements' ? 'wf-bg-blue-700' : ''"
              href="#"
              @click.prevent="menu = 'elements'"
            >
              <i class="fas fa-clone"></i>
              <span class="wf-text-xxs wf-lowercase">Elements</span>
            </a>
          </li>
          <li>
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-text-xl wf-cursor-pointer wf-text-white hover:bg-blue-700"
              :class="menu == 'settings' ? 'wf-bg-blue-700' : ''"
              href="#"
              @click.prevent="menu = 'settings'"
            >
              <i class="fas fa-cogs"></i>
              <span class="wf-text-xxs wf-lowercase">Settings</span>
            </a>
          </li>
          <li class="wf-mt-auto">
            <a
              class="wf-flex wf-flex-col wf-items-center wf-py-4 wf-bg-green-500 wf-text-xl wf-cursor-pointer wf-text-white hover:wf-bg-green-700"
              href="#"
              @click.prevent="publish"
            >
              <i class="fas fa-check-circle"></i>
              <span class="wf-text-xxs wf-lowercase">Publish</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="wf-w-5/6 wf-bg-white wf-pt-3 wf-px-3 wf-max-h-screen wf-pb-12">
        <div v-if="menu == 'meta'">
          <div>
            <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
              <i class="fas wf-text-sm fa-info-circle"></i>
              <span>Page Information</span>
            </h4>
            <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
          </div>
          <div class="mt-3">
            <label for="page_title" class="text-xs uppercase font-light text-gray-500">Title</label>
            <input
              v-model="pageTitle"
              id="page_title"
              type="text"
              class="focus:bg-gray-300 wf-text-sm w-full bg-gray-200 rounded focus:outline-none px-2 py-1"
            >
          </div>
          <div class="mt-3">
            <label for="page_description" class="text-xs uppercase font-light text-gray-500">Description</label>
            <textarea
              v-model="pageDescription"
              id="page_description"
              type="text"
              class="focus:bg-gray-300 h-20 resize-none wf-text-sm w-full bg-gray-200 rounded focus:outline-none px-2 py-1"
            ></textarea>
          </div>
          <div class="mt-3 text-right">
            <input id="facebook_meta" type="checkbox">
            <label for="facebook_meta" class="text-xs uppercase text-gray-500">Add Facebook tags</label>
          </div>
          <custom-tags></custom-tags>
        </div>
        <div v-if="menu == 'styles'">
          <div>
            <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
              <i class="fab wf-text-sm fa-css3"></i>
              <span>Style</span>
            </h4>
            <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
            <div class="wf-mt-3 wf-border">
              <CodeEditor mode="css" v-model="pageStyles" theme="eclipse"/>
            </div>
          </div>
        </div>
        <div v-if="menu == 'scripts'">
          <div>
            <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
              <i class="fab wf-text-sm fa-js"></i>
              <span>Scripts</span>
            </h4>
            <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
            <div class="mt-3">
              <textarea
                v-model="pageScripts"
                id="page_scripts"
                type="text"
                class="focus:bg-gray-300 h-48 resize-none text-xs font-mono text-gray-700 w-full bg-gray-200 rounded focus:outline-none px-2 py-1"
              ></textarea>
            </div>
          </div>
        </div>
        <div v-if="menu == 'pixels'">
          <div>
            <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
              <i class="fas wf-text-sm fa-cubes"></i>
              <span>Pixels</span>
            </h4>
            <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
          </div>
        </div>
        <div v-if="menu == 'elements'">
          <slot name="elements"></slot>
        </div>
        <div v-show="menu == 'settings'">
          <div>
            <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
              <i class="fas wf-text-sm fa-cogs"></i>
              <span>Settings</span>
            </h4>
            <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
              <div class="mt-3">
                <EditorSettings/>
              </div>
              <div class="wf-mt-5">
                <!-- <ColorPalettesSettings/> -->
              </div>
              <div class="wf-mt-5">
                <!-- <FontsSettings/> -->
              </div>
          </div>
        </div>
      </div>
      <button
        @click.prevent="toolbar = ! toolbar"
        class="focus:wf-outline-none wf-bg-blue-500 wf-flex wf-items-center wf-justify-center wf-mb-12 wf-bottom-0 wf-cursor-pointer wf-h-12 hover:wf-bg-blue-700 hover:wf-shadow-lg wf-rounded-br-lg wf-shadow wf-w-12 wf-absolute"
        style="right: -48px;"
      >
        <i
          class="fas wf-text-white wf-text-lg"
          :class="! toolbar ? 'fa-cogs' : 'fa-times'"
        ></i>
      </button>
      <EditorPreviewModeButton />
    </div>
    <div
      @click.prevent="toolbar = false"
      style="background: rgba(0,0,0,.25);"
      id="toolbar-overlay"
      class="wf-fixed wf-w-screen wf-h-screen wf-top-0 wf-z-10"
      :class="toolbar ? 'wf-block' : 'wf-hidden'"
    ></div>
  </div>
</template>

<script>
  import EditorSettings from './Settings/EditorSettings'
  import CodeEditor from './CodeEditor'
  import EditorPreviewModeButton from './EditorPreviewModeButton'
  // import ColorPalettesSettings from '../Settings/ColorPalettesSettings'
  // import FontsSettings from '../Settings/FontsSettings'
  export default {
    props: {
      layout: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    components: {
      CodeEditor,
      EditorSettings,
      EditorPreviewModeButton,
      // ColorPalettesSettings,
      // FontsSettings
    },
    computed: {
      toolbar: {
        get() {
          return this.$store.state.toolbar
        },
        set(value) {
          this.$store.commit('updateToolbar', value)
        }
      },
      menu: {
        get() {
          return this.$store.state.menu
        },
        set(value) {
          this.$store.commit('updateMenu', value)
        }
      },
      pageTitle: {
        get() {
          return this.$store.getters['pageModule/meta'].title
        },
        set(value) {
          this.$store.commit('pageModule/updateTitle', value)
        }
      },
      pageDescription: {
        get() {
          return this.$store.getters['pageModule/meta'].description
        },
        set(value) {
          this.$store.commit('pageModule/updateDescription', value)
        }
      },
      pageStyles: {
        get() {
          return this.$store.getters['pageModule/styles']
        },
        set(value) {
          this.$store.commit('pageModule/updateStyles', value)
        }
      },
      pageScripts: {
        get() {
          return this.$store.getters['pageModule/scripts']
        },
        set(value) {
          this.$store.commit('pageModule/updateScripts', value)
        }
      },
    },
    methods: {
      publish() {
        this.$store.commit('export', {
          layout: this.layout
        })
      }
    }
  }
</script>
